import React, { useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import { Card, Space, Switch } from 'antd';

const LanguageSwitch = () => {
  const { changeLanguage } = useContext(LanguageContext);
  return (
    <Switch
      onChange={(change) => {
        changeLanguage && changeLanguage(change ? 'bn' : 'en');
      }}
      title={'Switch Language'}
    />
  );
};

export const LanguageSwitchDropDown = () => {
  return (
    <Card>
      <Space>
        বাংলা
        <LanguageSwitch />
      </Space>
    </Card>
  );
};
